import * as actions from './actionConstants';

export const getOrganizations = () => ({
	type: actions.GET_ORGANIZATIONS
});

export const getOrganizationsSuccess = (organizationsList, organizations) => ({
	type: actions.GET_ORGANIZATIONS_SUCCESS,
	organizationsList,
	organizations
});

export const getOrganizationsError = error => ({
	type: actions.GET_ORGANIZATIONS_ERROR,
	error
});



// WEBPACK FOOTER //
// ./src/actions/organizationActions.js